import React from 'react'

export const NotFound = () => {
  return <h1 className="mb-5 text-center">ページが見つかりません</h1>
}
